import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ComplianceState, complianceFeatureKey } from '../reducers/compliance.reducer';

export const getComplianceState = createFeatureSelector<ComplianceState>(complianceFeatureKey);
export const getComplianceLoading = createSelector(getComplianceState, state => state.loading);
export const getComplianceData = createSelector(getComplianceState, state => state.data);
export const getComplianceError = createSelector(getComplianceState, state => state.error);